module.exports = __webpack_public_path__ + "static/img/ordericon1.0da2de48.png";